/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { dashboardServices } from "../../../../service/dashboard";
import translationData from '../../../../locales/dashboardTranslation.json'
import { KpiCardNew, SectionHeaderNew } from "./KpiCardNew";
import { LuActivity, LuAlertTriangle, LuArchive, LuBox, LuCalendar, LuClock } from "react-icons/lu";

interface IncubationDetailsLayoutProps {
  heading: string;
  selectedDate: any;
}

const columnStyle = {
  margin: "0 0 6px 0",
  // borderBottom: '0.5px solid rgba(0, 0, 0, 0.11)'
};

const lastColumnStyle = {
  margin: "0",
};
const IncubationDetailsLayout: React.FC<IncubationDetailsLayoutProps> = ({
  heading,
  selectedDate
}) => {
  const navigate = useNavigate();

  interface ColumnData {
    id: number;
    apiName: string;
    displayName: string;
    count: number;
  }
  const [columnsData, setColumnsData] = useState<ColumnData[]>([]);

  const navigateToOtherPage = () => {
    navigate('/incubation-table'); 
  };

  const switchToPage = (id: number) => {
    if (id === 1){
      navigate(`/incubation-table`)
    }else if (id >= 3 && id <= 5) {
      navigate(`/inner-view-incubation/${id}`);
    }
  }

  const getIncubationStatus = async () => {
    try {
      const response = await dashboardServices.getIncubationStatus(selectedDate);
      if (response.status && response.statusCode === 200) {
        try {
          const responseData = response.data;
          if (responseData) {
            setColumnsData(prevColumnsData => {
              return prevColumnsData.map(column => {
                const { apiName, displayName } = column;

                const apiCount = responseData[apiName];

                if (apiCount !== undefined) {
                  return { ...column, count: apiCount };
                } else {
                  console.warn(`API response for ${displayName} is undefined or missing.`);
                  return column;
                }
              });
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('user response', error);
    }
  };

  useEffect(() => {
    const IncubationDataHead = translationData.IncubationDataHead;
    setColumnsData(IncubationDataHead.map((item => ({ ...item, count: 0 }))));
    }, []); 
  useEffect(() => {
    getIncubationStatus();
  }, [])

  const getIcon = (displayName: string) => {
    console.log(displayName, "displayName")
    switch (displayName) {
      case "Incubation Area":
        return LuArchive;
      case "Incubation Occupancy / Capacity":
        return LuActivity;
      case "Plates in Incubation":
        return LuBox;
      case "Plates Ready for Collection":
        return LuCalendar;
      case "Overdue plates for Collection":
        return LuClock;
      case "Deviations":
        return LuAlertTriangle;
      default:
        return LuArchive;
    }
  };

  const getColor = (displayName: string) => {
    switch (displayName) {
      case "Incubation Area":
        return "blue";
      case "Incubation Occupancy / Capacity":
        return "slate";
      case "Plates in Incubation":
        return "purple";
      case "Plates Ready for Collection":
        return "emerald";
      case "Overdue plates for Collection":
        return "rose";
      case "Deviations":
        return "orange";
      default:
        return "blue";
    }
  };

  const getColumnNameStyle = (column: any) => {
    if (column.displayName.includes('Overdue plates for Collection')) {
      return 'column-style redText';
    } else if (column.displayName.includes('Plates Ready for Collection')) {
      return 'column-style yellowText';
    }else {
      return 'column-style';
    }
  }
  return (
    // <div className="container">
    //   <h2 className="head-style" title="Click here to View Incubation Details" onClick={navigateToOtherPage}>
    //     {heading}
    //   </h2>
    //   <div className="columns" style={{ padding: "10px" }}>
    //      {columnsData.map((column) => (
    //       <div key={column.id} className="column" style={column.id === columnsData.length ? lastColumnStyle : columnStyle}>
    //       <div className="linkStyle" onClick={() => switchToPage(column.id)}>
    //       <span className={getColumnNameStyle(column)}>
    //         {column.displayName}
    //       </span>
    //       <span className="countStyle">{column.count}</span>
    //       </div>
    //       </div>
    //   ))}
    //   </div>
    // </div>

    // <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-stretch">
    <div className="flex flex-col">
      <SectionHeaderNew
        title={heading}
        onClick={navigateToOtherPage}
      />

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 flex-1">
        {columnsData.map((column) => (
          <div
            key={column.id}
            onClick={() => switchToPage(column.id)}
            className="cursor-pointer"
          >
            <KpiCardNew
              label={column.displayName}
              val={column.count}
              icon={getIcon(column.displayName)}
              color={getColor(column.displayName)}
              layout="mini"
              statusColor={
                column.displayName === "Overdue plates for Collection"
                  ? "text-rose-600"
                  : column.displayName === "Deviations"
                    ? "text-orange-600"
                    : undefined
              }
            />
          </div>
        ))}
      </div>
    </div>
      // </div>

  );
};

export default IncubationDetailsLayout;
